module.exports = __webpack_public_path__ + "img/supported_maix.64881bf9.png";